import { styled } from "styled-components";
import { Avatar } from "@/ui";

export const StyledPin = styled.button`
  padding: var(--spacing-sm) var(--spacing-md);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--color-white);
  background-color: var(--color-text-150);
  border: 1px solid var(--color-border-alpha);
  border-radius: 80px;
  position: absolute;
  z-index: 4;
  left: 50%;
  top: 50%;
  transform: scale(1) translate(-50%, -50%);
  opacity: 0;
  visibility: hidden;
  transition: all var(--transition-fast);
  white-space: nowrap;
  font-size: var(--font-size-md);
  pointer-events: none;
  &:active {
    transform: scale(0.96) translate(-50%, -50%);
  }
`;

export const StyledContent = styled.div<{
  $transparent?: boolean;
}>`
  display: flex;
  position: absolute;
  inset: 0;
  z-index: 2;
  background-color: ${({ $transparent }) => $transparent ? 'transparent' : 'var(--color-video-bg)'};
  &:hover {
    ${StyledPin} {
      opacity: 1;
      visibility: visible;
      pointer-events: all;
    }
  }
`;

export const StyledUserInfo = styled.div`
  position: absolute;
  z-index: 3;
  bottom: 12px;
  left: 20px;
  p {
    color: var(--color-white);
    padding: 0!important;
    margin: 0;
  }
`;

export const StyledMediaStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: var(--color-video-bg-light);
  border-radius: 50%;
`;

export const StyledAvatar = styled(Avatar)`
  border: 3px solid var(--color-avatar-border);
  z-index: 3;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
